import palette from './palette';
// import { textAlign } from '@mui/system';

export default {
  h1: {
    // color: palette.text.primary,
    fontWeight: 500,
    fontSize: '35px',
    letterSpacing: '-0.24px',
    // //lineHeight: '40px',
    textAlign:"justify"

  },
  h2: {
    // color: palette.text.primary,
    fontWeight: 500,
    fontSize: '29px',
    letterSpacing: '-0.24px',
    // //lineHeight: '40px',
    textAlign:"justify"

  },
  h3: {
    // color: palette.text.primary,
    fontWeight: 500,
    fontSize: '24px',
    letterSpacing: '-0.06px',
    // //lineHeight: '40px',
    textAlign:"justify"

  },
  h4: {
    // color: palette.text.primary,
    fontWeight: 500,
    fontSize: '20px',
    letterSpacing: '-0.06px',
    // //lineHeight: '40px',
    textAlign:"justify"

  },
  h5: {
    // color: palette.text.primary,
    fontWeight: 500,
    fontSize: '16px',
    letterSpacing: '-0.05px',
    //lineHeight: '40px',
    textAlign:"justify"

  },
  h6: {
    // color: palette.text.primary,
    fontWeight: 500,
    fontSize: '14px',
    letterSpacing: '-0.05px',
    ////lineHeight: '40px',
    textAlign:"justify"

  },
  subtitle1: {
    // color: palette.text.primary,
    fontSize: '16px',
    letterSpacing: '-0.05px',
    ////lineHeight: '40px',
    textAlign:"justify"

  },
  subtitle2: {
    // color: palette.text.secondary,
    fontWeight: 400,
    fontSize: '14px',
    letterSpacing: '-0.05px',
    ////lineHeight: '40px',
    textAlign:"justify"

  },
  body1: {
    // color: palette.text.primary,
    fontSize: '14px',
    letterSpacing: '-0.05px',
    //lineHeight: '40px',
    textAlign:"justify"

  },
  body2: {
    // color: palette.text.secondary,
    fontSize: '12px',
    letterSpacing: '-0.04px',
    //lineHeight: '40px',
    textAlign:"justify"

  },
  button: {
    // color: palette.text.primary,
    fontSize: '14px',
    textAlign:"justify"

  },
  caption: {
    // color: palette.text.secondary,
    fontSize: '11px',
    letterSpacing: '0.33px',
    //lineHeight: '40px',
    textAlign:"justify"
  },
  overline: {
    // color: palette.text.secondary,
    fontSize: '11px',
    fontWeight: 500,
    letterSpacing: '0.33px',
    //lineHeight: '40px',
    textTransform: 'uppercase',
    textAlign:"justify"

  }
};
